<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <el-scrollbar style='height: 100%;'>
        <div class="userBox">
            <div class="userlists" v-show='userdata'>

                <!-- 好友资料-头部 -->
                <div class="usertop">
                    <div class="imgbox"><img :src="userdata.avatar" alt=""></div>
                    <p class="name">{{userdata.nickname}}</p>
                    <a href="javascript:;" @click="sendMsg">发送消息</a>
                </div>

                <!-- 好友资料-列表-->
                <div class="userbot">
                    <ul>
                        <li>
                            <span>备注</span>
                            <div class="userlist">
                                <span v-show="!showeditnick">{{userdata.remark}}</span> <i @click='shownick' v-show="!showeditnick"
                                    class="choose"></i>
                                <input ref='nickinput' name='nick' @blur="saveremark" v-model="userdata.remark" type="text"
                                    maxlength="16" v-show="showeditnick">
                            </div>
                        </li>
                        <li>
                            <span>地区</span>
                            <div class="userlist">
                                <span>{{userdata.country}} {{userdata.province}} {{userdata.city}}</span>
                            </div>
                        </li>
                        <li>
                            <span>微信号</span>
                            <div class="userlist">
                                <span>{{userdata.friendWechatno?userdata.friendWechatno:userdata.friendid}}</span>
                            </div>
                        </li>
                        <li>
                            <span>状态</span>
                            <div class="userlist">
                                <span>{{userdata.outsideTransactionStatus==1? '已签约':'未签约'}}</span>
                            </div>
                        </li>
                        <li>
                            <span>标签</span>
                            <div class="userlist">
                                <span v-show="!showedittips">{{oldtips.str}}</span>
                                <i @click='edittips' v-show="!showedittips" class="choose"></i>
                                <div v-if="showedittips" class="edittipsbox">
                                    <el-scrollbar style="height: 100%;">
                                        <ul class="clearfix">
                                            <li v-for="(item,index) in tiplist" :key="index" @click="seltip(item.id,item.name)" :class="{'active':item.act==1}">{{item.name}}</li>
                                        </ul>
                                    </el-scrollbar>
                                    <span slot="footer" class="dialog-footer" v-if="showedittips">
                                        <el-button @click="showedittips = false">取 消</el-button>
                                        <el-button type="primary" @click="savetip">确 定</el-button>
                                    </span>
                                </div>
                            </div>
                        </li>
                        <li>
                            <span>好友来源</span>
                            <div class="userlist">
                                <span>{{userdata.addWaySource}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
    import {
        friendInfo,
        getFriendTag,
        editFriendTag,
        editWechatContactinfoRemark
    } from '@/utils/api-im'
    import {
        mapMutations,
        mapGetters
    } from 'vuex'
    export default {
        name: "userInfo",
        data() {
            return {
                showeditnick: false,
                userdata: '',
                oldtips: {
                    str:'',
                    arr:[]
                },
                showedittips: false,
                tiplist:[]
            }
        },
        props: {
            otheruserdata: {},
        },
        watch: {
            'otheruserdata.id'() {
                this.getinfo()
            }
        },
        computed: {
            ...mapGetters('im', [
                'chatlist',
                'chatdata',
                'selectfriendids'
            ])
        },
        mounted() {
        },
        methods: {
            ...mapMutations('im', [
                'SELECTFRIEND',
                'SELECTFRIENDINFO',
                'SELECTCHAT'
            ]),

            savetip(){
                this.showedittips = false
                let arr = new Array()
                let tipstr = []
                for(let i = 0;i<this.tiplist.length;i++){
                    if(this.tiplist[i].act==1){
                        arr.push({
                            tagId:this.tiplist[i].id,
                            wechatContactinfoId:this.userdata.id
                        })
                        tipstr.push(this.tiplist[i].name)
                    }
                }
                this.$post(editFriendTag,arr).then(res=>{
                    if(res.data.code ==200){
                        this.oldtips ={
                            str:tipstr.join(';'),

                        }
                    }
                })
            },

            seltip(id){
                for(let i = 0;i<this.tiplist.length;i++){
                    if(this.tiplist[i].id==id){
                        if(this.tiplist[i].act == 1){
                            this.tiplist[i].act =0
                        }else{
                            this.tiplist[i].act =1
                        }
                    }
                }
                let str = JSON.stringify(this.tiplist)
                this.tiplist = JSON.parse(str)
            },

            edittips() {
                this.showedittips = true
            },
            //修改昵称
            shownick() {
                this.showeditnick = true;
                this.$nextTick(function() {
                    this.$refs.nickinput.focus()
                })
            },
            //发消息
            sendMsg() {
                let {
                    friendid,
                    wechatid,
                    avatar,
                    nickname,
                    remark
                } = this.userdata;
                console.log(this.userdata,'this.userdata')
                this.SELECTFRIEND({
                    wechatContactinfo: this.userdata,
                    wechatMessage: {
                        page: 0,
                        data: []
                    }
                })
                this.$router.push({
                    name: 'chat',
                    params: {
                        friendid: this.otheruserdata.fid,
                        wechatid: this.otheruserdata.wid,
                        avatar: avatar,
                        nickname: nickname,
                        remark: remark,
                        type: 1,
                        outsideCustomerId: this.userdata.outsideCustomerId,
                        weChatNiceName: this.userdata.weChatNiceName,
                        wechatAvatar: this.userdata.wechatAvatar
                    }
                })
            },

            getinfo() {
                this.showedittips = false
                this.oldtips = {
                    str:'',
                    arr:[]
                }
                //获取好友信息
                this.$post(friendInfo, {
                    id: this.otheruserdata.id
                }).then(res => {
                    if (res.status == 200) {
                        this.userdata = res.data.data
                        if(this.userdata.friendTagList&&this.userdata.friendTagList.length>0 ){
                            let arr = []
                            for(let i=0;i<this.userdata.friendTagList.length;i++){
                                arr.push(this.userdata.friendTagList[i].tagName)
                            }
                            this.oldtips ={
                                str:arr.join(';'),
                                arr:res.data.data.friendTagList
                            }
                        }
                    } else {
                        this.$toast(res.data.msg);
                    }
                    this.gettips()
                })

            },

            gettips(){
                this.$get(getFriendTag).then(res=>{

                    this.tiplist = res.data.data
                    for(let i=0;i< this.tiplist.length;i++){
                        this.tiplist[i].act =0
                        for(let j=0;j< this.oldtips.arr.length;j++){
                            if(this.oldtips.arr[j].id == this.tiplist[i].id){
                                this.tiplist[i].act =1
                            }
                        }
                    }
                })
            },

            saveremark() {
                this.$post(editWechatContactinfoRemark, {
                    friendid: this.otheruserdata.fid,
                    remark: this.userdata.remark,
                    wechatid: this.otheruserdata.wid
                }).then(res => {
                    if (res.data.code == 200) {
                        //更新会话好友信息
                        let olddata = this.chatlist;
                        for (let i = 0; i < olddata.records.length; i++) {
                            if (olddata.records[i].friendid == this.otheruserdata.fid && olddata.records[i].wechatid ==
                                this.otheruserdata.wid) {
                                olddata.records[i].remark = this.userdata.remark
                            }
                        }
                        this.SELECTCHAT(olddata)
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        if (this.selectfriendids.wechatContactinfo.friendid == this.otheruserdata.fid && this.selectfriendids
                            .wechatContactinfo.wechatid == this.otheruserdata.wid) {
                            let newinfo = this.selectfriendids.wechatContactinfo
                            newinfo.remark = this.userdata.remark
                            this.SELECTFRIENDINFO(newinfo)
                        }
                        this.showeditnick = false

                        this.$emit('changeremark', {
                            friendid: this.otheruserdata.fid,
                            remark: this.userdata.remark,
                            wechatid: this.otheruserdata.wid
                        })
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .userBox {
        min-width: 396px;
        width: 100%;
        padding-top: 67px;

        .userlists {
            width: 396px;
            margin: 0 auto;

            /* 好友资料-头部*/
            .usertop {
                text-align: center;
                border-bottom: 1px solid rgba(226, 231, 235, 1);

                .imgbox {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    background: rgba(0, 0, 0, 0.3);
                    overflow: hidden;
                    margin: 0 auto;
                }

                img {
                    width: 60px;
                    height: 60px;

                }

                .name {
                    margin-top: 20px;
                    font-size: 18px;
                    line-height: 18px;
                    height: 18px;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0 30px;
                }

                a {
                    display: inline-block;
                    width: 136px;
                    height: 40px;
                    background: rgba(0, 153, 255, 1);
                    border-radius: 2px;
                    line-height: 40px;
                    color: #fff;
                    font-size: 14px;
                    margin: 30px 0;
                }
            }

            /* 好友资料-列表*/
            .userbot {
                padding-top: 28px;
                font-size: 14px;

                li {
                    margin-bottom: 10px;
                    line-height: 28px;

                    &>span {
                        color: #93999F;
                        display: inline-block;
                        width: 100px;
                        text-align: right;
                        vertical-align: top;
                    }

                    .userlist {
                        display: inline-block;
                        min-height: 28px;
                        margin-left: 30px;
                        width: 260px;
                        vertical-align: top;

                        span {
                            display: inline-block;
                            max-width: 220px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            vertical-align: middle;
                        }

                        input {
                            width: 220px;
                            border: 1px solid transparent;
                            border-radius: 2px;
                            font-size: 14px;
                        }

                        i {
                            cursor: pointer;
                            display: inline-block;
                            width: 15px;
                            height: 15px;
                            background: url(/static/img/choose.png) center no-repeat;
                            margin-left: 8px;
                            vertical-align: middle;

                        }

                        .edittipsbox {
                            height: 200px;
                            width: 500px;
                            padding: 10px 10px 84px;
                            border-radius: 2px;
                            border: 1px solid rgba(235, 235, 235, 1);
                            position: relative;

                            li {
                                float: left;
                                height: 32px;
                                margin-right: 8px;
                                margin-bottom: 12px;
                                padding: 0 8px;
                                background: rgba(218, 222, 224, 0.06);
                                border-radius: 2px;
                                border: 1px solid rgba(218, 222, 224, 0.6);
                                cursor: pointer;

                                &.active{
                                    background:rgba(236,245,255,1);
                                    border:1px solid rgba(224,237,255,1);
                                    color: #0099FF;
                                }
                            }

                            .dialog-footer {
                                position: absolute;
                                right: 20px;
                                bottom: 30px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/userInfo.vue